import { defineMessages } from 'react-intl';

export const datePickerMessages = defineMessages({
    datePickerDeliveryMessageFuture: {
        id: 'datePicker.deliveryMessageFuture',
        description: 'Message for displaying estimated delivery time for future delivery',
        defaultMessage: 'Cards are sent at approximately <strong>8AM EST</strong> on the selected date.'
    },
    datePickerToday: {
        id: 'datePicker.datePickerToday',
        description: 'Today value to display when the current date is today\'s date',
        defaultMessage: 'Today'
    },
    datePickerTodayButton: {
        id: 'datePicker.datePickerTodayButton',
        description: 'Message to display on the Today button of the datepicker',
        defaultMessage: 'Set Delivery Date To Today'
    }
});
